<template>
  
  <div class="theming"> 
  	<select v-model="theme" v-on:change="changeTheme"> 
  		<option value="">Old IARC</option>
  		<option value="theme1">New IARC Dark Blue</option>
  		<option value="theme2">New IARC Peach</option>
  		<!--<option value="theme3">New IARC Ivory</option>-->
  	</select>

    
  </div>

</template>

<script>

import { VBTooltip } from 'bootstrap-vue'

export default {
  name: 'Theming',
  data: function(){
    return {
        theme : 'theme1'
    } 
  },
  mounted(){
    this.changeTheme();
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  methods : {
    changeTheme : function(){

    	// 
    	$('body').attr('class',this.theme) ; 	

    	// set globallyt
    	this.$store.commit('setTheme',this.theme) ; 
    }
  }
};

</script>

<style lang="scss">

.theming{
	position: absolute ; 
	left: 0 ; 
	top: 20px ;
    z-index: 99;
    display: block;
}


@font-face {
  font-family: "Frutiger-LT-65-Bold";
  src: url("../assets/fonts/Frutiger-LT-65-Bold.woff") format("woff");
}

@font-face {
  font-family: "Frutiger-LT-Com-55-Roman";
  src: url("../assets/fonts/Frutiger-LT-Com-55-Roman.woff") format("woff");
}

@font-face {
    font-family: 'PP Object Sans';
    src: url('../assets/fonts/PPObjectSans-Bold.woff2') format('woff2'),
        url('../assets/fonts/PPObjectSans-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Frutiger';
    src: url('../assets/fonts/FrutigerBold.woff2') format('woff2'),
        url('../assets/fonts/FrutigerBold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'PP Object Sans';
    src: url('../assets/fonts/PPObjectSans-Light.woff2') format('woff2'),
        url('../assets/fonts/PPObjectSans-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'PP Object Sans Slanted';
    src: url('../assets/fonts/PPObjectSans-BoldSlanted.woff2') format('woff2'),
        url('../assets/fonts/PPObjectSans-BoldSlanted.woff') format('woff');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'PP Object Sans';
    src: url('../assets/fonts/PPObjectSans-HeavySlanted.woff2') format('woff2'),
        url('../assets/fonts/PPObjectSans-HeavySlanted.woff') format('woff');
    font-weight: 900;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Futura';
    src: url('../assets/fonts/FuturaBT-Light.woff2') format('woff2'),
        url('../assets/fonts/FuturaBT-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'PP Object Sans';
    src: url('../assets/fonts/PPObjectSans-Regular.woff2') format('woff2'),
        url('../assets/fonts/PPObjectSans-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Lato';
    src: url('../assets/fonts/Lato-Bold.woff2') format('woff2'),
        url('../assets/fonts/Lato-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'PP Object Sans';
    src: url('../assets/fonts/PPObjectSans-LightSlanted.woff2') format('woff2'),
        url('../assets/fonts/PPObjectSans-LightSlanted.woff') format('woff');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'PP Object Sans';
    src: url('../assets/fonts/PPObjectSans-Heavy.woff2') format('woff2'),
        url('../assets/fonts/PPObjectSans-Heavy.woff') format('woff');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Lato';
    src: url('../assets/fonts/Lato-Regular.woff2') format('woff2'),
        url('../assets/fonts/Lato-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'PP Object Sans Slanted';
    src: url('../assets/fonts/PPObjectSans-Slanted.woff2') format('woff2'),
        url('../assets/fonts/PPObjectSans-Slanted.woff') format('woff');
    font-weight: normal;
    font-style: italic;
    font-display: swap;
}

$dark_blue : #303153 ; 
$peach : #B05A3F ; 
$ivory : #F1EEDF ; 
$blue_iarc : #1E7FB8	 ;

$font_pp_object_sans : "PP Object Sans";
$font_frutiger : "Frutiger" ;
$font_futura : 'Futura';
$font_lato : 'Lato' ;

/* Dark blue */
body.theme1{
    font-family: $font_pp_object_sans  !important;
    a{
  	 color: $peach ;
    }
	#app {

		header,
		.follow,
		.list-group .list-group-item.active,
		#bloc_left table thead tr,
		.database table thead tr,
		#container-filters .filters .radios_toggle input[type=radio]:checked + label, 
		#container-filters .filters .radios_toggle input[type=checkbox]:checked + label, 
		#container-filters .filters .checkbox_toggle input[type=radio]:checked + label, 
		#container-filters .filters .checkbox_toggle input[type=checkbox]:checked + label,
		form .multiselect__tag,
		form .vue-slider-process,
        table.datatable tr th,
        #table-container .nav-tabs .nav-link.active, #table-container .nav-tabs .nav-item.show .nav-link,
        ul.sub-menu li a.router-link-active,
        .radios_buttons input[type=radio]:checked + label, 
        .radios_buttons input[type=checkbox]:checked + label,
        .filters .radios_toggle label.checked
		{
			background-color: $dark_blue !important; 
		}

        #container-filters a.nav-link.active{
            color: $dark_blue !important; 
        }

        header{
            /*background-image:url('/subsites/overtime/assets/img/bubble.png');*/
            background-repeat:no-repeat;
            border-bottom: solid 1px #fff ; 
        }

        .home_box{
            h1{
                font-size: 2.4em!important;
                span{
                    color: $peach ; 
                }
            }

            .col-home-box{
                padding: 15px 15px 15px 15px;
                flex: 0 0 33%!important;
                max-width: 33%!important;
            }

            .col-home-box-large{
                padding: 15px 15px 15px 15px;
                flex: 0 0 50%!important;
                max-width: 50%!important;
            }

            .preview{
                display: block; 
                margin: auto ; 
                max-width: 175px;
                img{
                    max-height: 170px;
                    max-width: 100%;
                }
            }
        }

        ul.downloads li span.icon{
            background-color: $dark_blue ;
        }

        ul.sub-menu li {
            a.router-link-active,
            a:hover{
                border-color:$dark_blue ;
            }
        }

		.list-group-item.active{
			border:$dark_blue ;
		}
		.page h2,
		form fieldset h4,
        form fieldset.container_populations a.emptyPopButton i{
			color: $peach ; 
		}
		.breadcrumb{
			background:$ivory!important;
		}
		h5.publishing,
        .sub-menu-tabs .nav-tabs .nav-link.active, 
        .sub-menu-tabs .nav-tabs .nav-item.show .nav-link{
			color: $dark_blue ; 
		}
		.follow .content ul.social li a i,
		ul.footer_links li i{
			color: $peach !important;
		}

        #container-filters .filters .radios_toggle label, 
        #container-filters .filters .checkbox_toggle label,
        .title_l1,.title_l2{
            color: $dark_blue;
        }

        .graphic svg {
            .axis text{
                /*font-size: 1.4em!important;*/
            }
            text,tspan{
                font-family: $font_pp_object_sans !important;
            }
        }

        table.datatable#populations{
            font-size: 0.8em;
            
        }

		footer,
		/*#container-filters a.nav-link.active,
		#container-filters .filters,
        ul.sub-menu,
        .sub-menu-tabs .nav-tabs .nav-link.active, 
        .sub-menu-tabs .nav-tabs .nav-item.show .nav-link*/
        {
			background-color: $ivory ; 
		}

        footer{
            border-top: solid 1px #fff ; 
        }

		a.btn_clear,
        /*.pretty.p-switch .state label:after*/,
        .tooltip > .tooltip-inner,
        ul.downloads li span.csv{
			background: $peach !important;
            background-color: $peach !important ;
		}

        /*.pretty.p-switch .state:before{
            border-color: $peach!important;
        }*/

        footer{
            /*background-image:url('/assets/img/metaball1.png')*/
        }
	}
}


/* Peach */
body.theme2{
	font-family: $font_pp_object_sans  !important;
	#app {
		header,.follow{
			background-color: $peach ; 
		}
	}
}

/* Ivory */
body.theme3{
	font-family: $font_pp_object_sans !important;
	#app {
		header,.follow{
			background-color: $ivory ; 
		}
	}
}

</style>